module.exports = __webpack_public_path__ + "img/top4_right.7bcbcba9.png";